import React from "react";

import { Link } from "react-router-dom";

import api from "../../Environment";
import Helper from "../Helper/helper";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../Helper/toaster";

import { translate } from "react-multi-lang";
import configuration from "react-global-configuration";
import {
  StandalonePageHeader,
  StandalonePageLogo,
} from "../Layouts/SubLayout/StandalonePageLogo";

class ForgotPasswordComponent extends Helper {
  state = {
    data: {
      email: "",
    },
    loadingContent: null,
    buttonDisable: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const email = (this.state.data && this.state.data.email) || "";
    this.setState({
      loadingContent: this.props.t("loading_text"),
      buttonDisable: true,
    });
    api
      .postMethod("forgotpassword", { email })
      .then((response) => {
        ToastDemo(
          this.props.toastManager,
          this.props.t("forgot_password_text"),
          "success"
        );
        this.setState({
          loadingContent: null,
          buttonDisable: false,
          data: { email: "" },
        });
        this.props.history.push("/login");
      })
      .catch((error) => {
        this.setState({ loadingContent: null, buttonDisable: false });
        const status =
          error && error.response && error.response.status;
        if (status === 429) {
          ToastDemo(
            this.props.toastManager,
            "Too many password reset requests. Try again later.",
            "error"
          );
          return;
        }
        ToastDemo(
          this.props.toastManager,
          this.props.t("forgot_password_text"),
          "success"
        );
      });
  };
  render() {
    const { t } = this.props;

    var bgImg = {
      backgroundImage: `url(${configuration.get(
        "configData.common_bg_image"
      )})`,
    };

    return (
      <div>
        <div className="common-bg-img" style={bgImg}>
          <StandalonePageHeader variant="auth">
            <StandalonePageLogo linkTo="/" />
          </StandalonePageHeader>

          <div className="row">
            <div className="col-sm-9 col-md-7 col-lg-5 col-xl-4 auto-margin">
              <div className="register-box">
                <h3 className="register-box-head">{t("forgot_password")}</h3>
                <form className="auth-form login-new-form" onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label className="sr-only" htmlFor="email">
                      {t("email_address")}
                    </label>
                    <input
                      type="email"
                      onChange={this.handleChange}
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder={t('example_email')}
                      aria-label={t("email_address")}
                      value={this.state.data.email}
                    />
                  </div>
                  <p className="mt-4 grey-text">{t("forgot_password_text")}</p>
                  <button
                    className="btn btn-danger auth-btn"
                    disabled={this.state.buttonDisable}
                  >
                    {this.state.loadingContent != null
                      ? this.state.loadingContent
                      : this.props.t("submit")}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withToastManager(translate(ForgotPasswordComponent));
